import store from '@/store'

export default [
  {
    path: '/schedule-times',
    name: 'schedule-time',
    meta: { requiresAuth: true },
    component: () => import('@/pages/schedule-time/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('scheduleTime/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/schedule-times/:id',
    name: 'schedule-time-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/schedule-time/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('scheduleTime/dataBeforeCreate')
      await store.dispatch('scheduleTime/find', to.params.id)
      next()
    }
  }
]
